
export default item => ({
  slug: item.id,
  name: `${item.type} (${item.minInsuredAward})`,
  price: {
    ...item.price
  }
})
